import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid2,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { userCategories, userCats } from '../../../helpers/appstate';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import {
  getLga,
  getRolesByUserCategory,
  getStates,
  getZones,
  inviteUsers,
} from '../../../helpers/api';
import { openNotification } from '../../../helpers/notification';
import { Empty, Skeleton } from 'antd';
import { Info } from '@mui/icons-material';
import FormList from 'antd/lib/form/FormList';
import InviteRolePrivilegePreview from './InviteRolePrivilegePreview';

const InviteUserScreen = withRouter(({ history }) => {
  const initZone = { zoneId: '', zoneName: '' };
  const initState = { stateId: '', stateName: '' };
  const initLga = { lgaId: '', lgaName: '' };

  const [emailAddresses, setEmailAddresss] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [roleLoading, setRoleLoading] = useState(false);
  const [roleSelected, setRoleSelected] = useState();
  const [dialogRole, setDialogRole] = useState(false);
  const [zoneList, setZoneList] = useState([]);
  const [zoneLoading, setZoneLoading] = useState(false);
  const [zoneSelected, setZoneSelected] = useState(initZone);
  const [zoneSelectedList, setZoneSelectedList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const [stateSelected, setStateSelected] = useState(initState);
  const [stateSelectedList, setStateSelectedList] = useState([]);
  const [lgaList, setLgaList] = useState([]);
  const [lgaLoading, setLgaLoading] = useState(false);
  const [lgaSelected, setLgaSelected] = useState(initLga);
  const [lgaSelectedList, setLgaSelectedList] = useState([]);
  const [sending, setSending] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
      userCategory: '',
      roleId: '',
      locationOption: '',
      zoneId: '',
      stateId: '',
      lgaId: '',
    },
    onSubmit: (values) => {},
  });

  useEffect(() => {
    if (formik.values.userCategory) {
      fetchRoleList();
    }
    formik.setFieldValue('roleId', '');
  }, [formik.values.userCategory]);

  useEffect(() => {
    fetchZoneList();
    fetchStateList();
    fetchLgaList();
  }, []);

  useEffect(() => {
    setZoneSelectedList([]);
    setStateSelectedList([]);
    setLgaSelectedList([]);
  }, [formik.values.locationOption]);

  const handleAddEmailToList = (e) => {
    if (!formik.values.email || formik.values.email === ' ') {
      return;
    }

    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formik.values.email);
    if (!isValidEmail) {
      openNotification({
        type: 'error',
        message: `${formik.values.email} is not a valid email`,
      });
      return;
    }

    const exists = emailAddresses?.filter((x) => x === formik.values.email)?.length > 0;
    if (exists) {
      openNotification({
        type: 'error',
        message: `${formik.values.email} already in list`,
      });
      return;
    }

    setEmailAddresss((prev) => [...prev, formik.values.email]);
    formik.setFieldValue('email', '');
  };

  const handleRemoveEmailFromList = (email) => {
    const filtered = emailAddresses?.filter((x) => x !== email);
    setEmailAddresss(filtered);
  };

  const handleSelectRole = (value) => {
    formik.setFieldValue('roleId', value);
  };

  const handleAddZoneToList = (zone) => {
    if (!zone) {
      return;
    }

    const exists = zoneSelectedList?.filter((x) => x.zoneId === zone?.zoneId)?.length > 0;
    if (exists) {
      openNotification({
        type: 'error',
        message: `${zone?.zoneName} already in list`,
      });
      return;
    }

    setZoneSelectedList((prev) => [...prev, zone]);
    setZoneSelected(initZone);
  };

  const handleRemoveZoneFromList = (zone) => {
    const filtered = zoneSelectedList?.filter((x) => x.zoneId !== zone?.zoneId);
    setZoneSelectedList(filtered);
  };

  const handleAddStateToList = (state) => {
    if (!state) {
      return;
    }

    const exists = stateSelectedList?.filter((x) => x.stateId === state?.stateId)?.length > 0;
    if (exists) {
      openNotification({
        type: 'error',
        message: `${state?.stateName} already in list`,
      });
      return;
    }

    setStateSelectedList((prev) => [...prev, state]);
    setStateSelected(initState);
  };

  const handleRemoveStateFromList = (state) => {
    const filtered = stateSelectedList?.filter((x) => x.stateId !== state?.stateId);
    setStateSelectedList(filtered);
  };

  const handleAddLgaToList = (lga) => {
    if (!lga) {
      return;
    }

    const exists = lgaSelectedList?.filter((x) => x.lgaId === lga?.lgaId)?.length > 0;
    if (exists) {
      openNotification({
        type: 'error',
        message: `${lga?.lgaName} already in list`,
      });
      return;
    }

    setLgaSelectedList((prev) => [...prev, lga]);
    setLgaSelected(initLga);
  };

  const handleRemoveLgaFromList = (lga) => {
    const filtered = lgaSelectedList?.filter((x) => x.lgaId !== lga?.lgaId);
    setLgaSelectedList(filtered);
  };

  const handleSendInvite = async () => {
    setSending(true);
    try {
      if (emailAddresses?.length < 1) {
        openNotification({
          type: 'error',
          message: 'You must enter at least one email to invite',
        });
        return;
      }

      if (!formik.values.userCategory) {
        openNotification({
          type: 'error',
          message: 'User Category is required',
        });
        return;
      }

      if (!formik.values.roleId) {
        openNotification({
          type: 'error',
          message: 'Role is required',
        });
        return;
      }

      if (
        formik.values.userCategory === 1 &&
        zoneSelectedList?.length < 1 &&
        stateSelectedList?.length < 1 &&
        lgaSelectedList?.length < 1
      ) {
        openNotification({
          type: 'error',
          message: 'You must select at least one Zone or State or Lga',
        });
        return;
      }

      const zoneIds = zoneSelectedList?.map((i) => {
        return i.zoneId;
      });
      const stateIds = stateSelectedList?.map((i) => {
        return i.stateId;
      });
      const lgaIds = lgaSelectedList?.map((i) => {
        return i.lgaId;
      });

      const payload = {
        email: emailAddresses,
        roleId: formik.values.roleId,
        userCategory: formik.values.userCategory,
        facilityId: [],
        zoneId: zoneIds,
        stateId: stateIds,
        lgaId: lgaIds,
      };

      const res = await inviteUsers(payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({
          type: 'success',
          message: status?.desc,
        });
      } else {
        openNotification({
          type: 'error',
          message: status?.desc,
        });
      }
    } catch (error) {
      console.log(error);
      openNotification({
        type: 'error',
        message: 'Something went wrong. Please try again later',
      });
    } finally {
      setSending(false);
    }
  };

  const fetchRoleList = async () => {
    setRoleLoading(true);
    try {
      const res = await getRolesByUserCategory(formik.values.userCategory);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setRoleList(data);
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      openNotification({ type: 'error', message: 'Something went wrong' });
    } finally {
      setRoleLoading(false);
    }
  };

  const fetchZoneList = async () => {
    setZoneLoading(true);
    try {
      const res = await getZones();
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setZoneList(data);
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      openNotification({ type: 'error', message: 'Unable to retrieve list of Zones' });
    } finally {
      setZoneLoading(false);
    }
  };

  const fetchStateList = async () => {
    try {
      const res = await getStates();
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setStateList(data);
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      openNotification({ type: 'error', message: 'Unable to retrieve list of States' });
    } finally {
    }
  };

  const fetchLgaList = async () => {
    try {
      const res = await getLga();
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setLgaList(data);
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      openNotification({ type: 'error', message: 'Unable to retrieve list of LGAs' });
    } finally {
    }
  };

  const handleRenderRoles = () => {
    if (roleLoading) {
      return (
        <Box>
          <Skeleton />
        </Box>
      );
    } else {
      if (roleList?.length > 0) {
        return renderRoles();
      }
    }
  };

  const renderRoles = () => {
    return (
      <Box border={1} borderColor="divider" px={3} py={2} boxShadow={1} bgcolor="#FFFFFF">
        <Typography fontWeight={600} color="textSecondary">
          Select Role
        </Typography>

        <Box mt={2}>
          <RadioGroup>
            {roleList?.map((i, index) => {
              return (
                <ListItem sx={{ mx: 0, px: 0, py: 0, my: 0 }}>
                  <ListItemText sx={{ mx: 0, px: 0, py: 0, my: 0 }}>
                    <FormControlLabel
                      value={i?.roleId}
                      name="roleId"
                      control={<Radio size="small" />}
                      label={i?.roleName}
                      onChange={(val) => handleSelectRole(val.target.value)}
                    />
                  </ListItemText>
                  <IconButton
                    onClick={() => {
                      setRoleSelected(i);
                      setDialogRole(true);
                    }}
                  >
                    <Info />
                  </IconButton>
                </ListItem>
              );
            })}
          </RadioGroup>
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ padding: '1rem', background: '#f9f9f9', minHeight: '100vh' }}>
      <Box padding="1rem" sx={{ display: 'flex', alignItems: 'center' }}>
        <Breadcrumbs sx={{ flexGrow: 1 }}>
          <Link to="/users">
            <Typography variant="body2" color="info.main">
              Users
            </Typography>
          </Link>
          <Typography variant="body2" color="textPrimary">
            Invite
          </Typography>
        </Breadcrumbs>
      </Box>
      <Box
        sx={{
          padding: '1rem',
          margin: { lg: '0 12rem', md: '0 12rem', sm: '0rem', xs: '0rem' },
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Typography fontWeight={600}>Users Email Addresses</Typography>
            <Typography variant="body2" color="textSecondary">
              Enter valid email, press enter to add to list
            </Typography>
          </Grid2>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TextField
              name="email"
              label="Email Addresses"
              placeholder="Enter Email Addresses"
              value={formik.values.email}
              onChange={formik.handleChange}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleAddEmailToList(e);
                }
              }}
              onBlur={(e) => handleAddEmailToList(e)}
              fullWidth
              sx={{ bgcolor: '#FFFFFF' }}
            />
          </Grid2>

          {emailAddresses?.length > 0 && (
            <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
              {emailAddresses?.map((i) => (
                <Chip label={i} onDelete={() => handleRemoveEmailFromList(i)} sx={{ mr: 0.5 }} />
              ))}
            </Grid2>
          )}

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}></Grid2>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Typography fontWeight={600}>Users Category and Roles</Typography>
          </Grid2>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Box>
              <FormControl fullWidth>
                <InputLabel id="userCategory">User Category</InputLabel>
                <Select
                  name="userCategory"
                  value={formik.values.userCategory}
                  label="userCategory"
                  onChange={formik.handleChange}
                  sx={{ bgcolor: '#FFFFFF' }}
                >
                  {userCategories
                    ?.filter((x) => x?.name === userCats.EDM || x?.name === userCats.REGULATOR)
                    ?.map((i, index) => (
                      <MenuItem value={i?.id} key={i?.id}>
                        {i?.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
            <Box mt={1}>{handleRenderRoles()}</Box>
          </Grid2>

          {formik.values.userCategory === 1 && (
            <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
              <br />
              <Typography fontWeight={600}>Administrative Area</Typography>

              <Box mt={2}>
                <FormControl fullWidth>
                  <InputLabel id="locationOption">Location Option</InputLabel>
                  <Select
                    name="locationOption"
                    value={formik.values.locationOption}
                    label="userCategory"
                    onChange={formik.handleChange}
                    sx={{ bgcolor: '#FFFFFF' }}
                  >
                    <MenuItem value="zone">Zone</MenuItem>
                    <MenuItem value="state">State</MenuItem>
                    <MenuItem value="lga">Lga</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid2>
          )}

          {formik.values.userCategory === 1 && formik.values.locationOption && (
            <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
              {formik.values.locationOption === 'zone' && (
                <Box>
                  <Autocomplete
                    fullWidth
                    disableCloseOnSelect
                    value={zoneSelected}
                    options={zoneList}
                    getOptionLabel={(option) => option.zoneName}
                    onChange={(e, value) => handleAddZoneToList(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Zone"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: zoneLoading && <CircularProgress size={20} />,
                        }}
                      />
                    )}
                    sx={{ bgcolor: '#FFFFFF' }}
                  />
                  {zoneSelectedList?.length > 0 && (
                    <Box mt={1}>
                      {zoneSelectedList?.map((i) => (
                        <Chip
                          key={i?.zoneId}
                          label={i?.zoneName}
                          onDelete={() => handleRemoveZoneFromList(i)}
                          sx={{ mr: 0.5 }}
                        />
                      ))}
                    </Box>
                  )}
                </Box>
              )}

              {formik.values.locationOption === 'state' && (
                <Box>
                  <Autocomplete
                    fullWidth
                    disableCloseOnSelect
                    value={stateSelected}
                    options={stateList}
                    getOptionLabel={(option) => option.stateName}
                    onChange={(e, value) => handleAddStateToList(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select State"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: stateLoading && <CircularProgress size={20} />,
                        }}
                      />
                    )}
                    sx={{ bgcolor: '#FFFFFF' }}
                  />
                  {stateSelectedList?.length > 0 && (
                    <Box mt={1}>
                      {stateSelectedList?.map((i) => (
                        <Chip
                          key={i?.stateId}
                          label={i?.stateName}
                          onDelete={() => handleRemoveStateFromList(i)}
                          sx={{ mr: 0.5 }}
                        />
                      ))}
                    </Box>
                  )}
                </Box>
              )}

              {formik.values.locationOption === 'lga' && (
                <Box>
                  <Autocomplete
                    fullWidth
                    disableCloseOnSelect
                    value={lgaSelected}
                    options={lgaList}
                    getOptionLabel={(option) => option.lgaName}
                    onChange={(e, value) => handleAddLgaToList(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Lga"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: lgaLoading && <CircularProgress size={20} />,
                        }}
                      />
                    )}
                    sx={{ bgcolor: '#FFFFFF' }}
                  />
                  {lgaSelectedList?.length > 0 && (
                    <Box mt={1}>
                      {lgaSelectedList?.map((i) => (
                        <Chip
                          key={i?.lgaId}
                          label={i?.lgaName}
                          onDelete={() => handleRemoveLgaFromList(i)}
                          sx={{ mr: 0.5 }}
                        />
                      ))}
                    </Box>
                  )}
                </Box>
              )}
            </Grid2>
          )}

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}></Grid2>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Button
              type="button"
              variant="contained"
              size="large"
              disabled={sending}
              startIcon={sending && <CircularProgress size={20} />}
              sx={{ textTransform: 'none' }}
              onClick={handleSendInvite}
            >
              Send Invite
            </Button>
          </Grid2>
        </Grid2>
      </Box>
      <br />
      <br />

      {dialogRole && (
        <InviteRolePrivilegePreview
          open={dialogRole}
          onClose={() => {
            setDialogRole(false);
          }}
          role={roleSelected}
        />
      )}
    </Box>
  );
});

export default InviteUserScreen;
